import { ChevronDown } from "lucide-react";
import type React from "react";

const HeroScrollIndicator: React.FC = () => {
  return (
    <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
      <div className="bg-white/20 border border-white/30 rounded-full p-3 backdrop-blur-sm animate-bounce">
        <ChevronDown className="w-6 h-6 text-white" />
      </div>
    </div>
  );
};

export default HeroScrollIndicator;
